import React, { useRef } from 'react';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

import { useDebriefModal } from 'ff/debrief/modalManager';
import InfoTable, {
    InfoTableRef,
} from 'ff/debrief/components/infoTable/InfoTable';
import DebriefDialogTitle from 'ff/debrief/components/modals/DebriefDialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { useCurrentTracklog } from 'ff/debrief/hooks';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import ReanalysisInProgressIndicator from 'ff/debrief/components/ReanalysisInProgressIndicator';

const OtherInfoModal = () => {
    const { isOpen, close } = useDebriefModal('OtherInfo');
    const { isOwnTracklog } = useCurrentTracklog();
    const infoTableRef = useRef<InfoTableRef>(null);
    const [isEditing, setIsEditing] = React.useState(false);

    const handleClose = () => {
        if (isEditing) {
            handleCancel();
        }
        close();
    };

    const handleCancel = () => {
        setIsEditing(false);
        infoTableRef.current?.reset();
    };

    const handleSave: () => void = () => {
        infoTableRef.current?.save().then(() => {
            setIsEditing(false);
        });
    };

    const handleEdit: () => void = () => {
        if (isOwnTracklog) {
            setIsEditing(true);
        }
    };

    return (
        <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
            <DebriefDialogTitle onClose={handleClose}>
                Flight Info
            </DebriefDialogTitle>
            <DialogContent sx={{ padding: '16px' }}>
                <InfoTable
                    editable={isOwnTracklog}
                    isEditing={isEditing}
                    ref={infoTableRef}
                />
            </DialogContent>
            <DialogActions sx={{ 'justify-content': 'center' }}>
                <Stack direction={'row'} gap={1}>
                    <ReanalysisInProgressIndicator />
                    {isEditing ? (
                        <Button onClick={handleCancel} variant="outlined">
                            Cancel
                        </Button>
                    ) : (
                        <Button onClick={handleClose} variant="outlined">
                            Close
                        </Button>
                    )}
                    {isOwnTracklog &&
                        (isEditing ? (
                            <Button onClick={handleSave} variant="contained">
                                Save
                            </Button>
                        ) : (
                            <Button
                                onClick={handleEdit}
                                variant="contained"
                                disabled={isEditing}
                            >
                                Edit Flight Info
                            </Button>
                        ))}
                </Stack>
            </DialogActions>
        </Dialog>
    );
};

export default OtherInfoModal;
